import { format } from 'date-fns';
import { TFunction } from 'i18next';
import { CampaignAudienceTypeEnum } from '../../enums';
import { CampaignBlastAudienceGroupDto, CampaignBlastAudienceToApplyDto } from '../../models/dto';

export const createGetAudienceOptionLabel =
	(tKey: string) =>
	(
		option: CampaignBlastAudienceToApplyDto,
		t: TFunction<'translation', undefined>,
		getEventName?: (baseId?: string, instance?: Date | string) => string | undefined,
		short?: boolean
	): string => {
		switch (option.type) {
			case CampaignAudienceTypeEnum.Member:
				return t(`${tKey}.${option.type}`);
			case CampaignAudienceTypeEnum.SubscribedMember:
				return t(`${tKey}.${option.type}`);
			case CampaignAudienceTypeEnum.Location:
				return option.city_name && option.state_name
					? `${option.city_name}, ${option.state_name}`
					: t(`${tKey}.${option.type}`);
			case CampaignAudienceTypeEnum.EventAttendee:
			case CampaignAudienceTypeEnum.EventWaitlistedUser:
			case CampaignAudienceTypeEnum.EventEarlyAccessUser:
				return option.event_baseId && option.event_instance
					? short
						? `${getEventName?.(option.event_baseId, option.event_instance) || ''}`
						: `${getEventName?.(option.event_baseId, option.event_instance) || ''} ${
								option.event_instance ? format(new Date(option.event_instance), 'EEE, MMM dd, HH:mm aa') : ''
						  }`
					: t(`${tKey}.${option.type}`);
			default:
				return '';
		}
	};

export const getAudienceOptionValue = (
	option: Pick<CampaignBlastAudienceGroupDto, 'type' | 'city_name' | 'state_name' | 'event_baseId' | 'event_instance'>
) => {
	switch (option.type) {
		case CampaignAudienceTypeEnum.Location:
			return option.state_name && option.city_name
				? `${option.type}_${option.state_name}_${option.city_name}`
				: option.type;
		case CampaignAudienceTypeEnum.EventAttendee:
		case CampaignAudienceTypeEnum.EventWaitlistedUser:
		case CampaignAudienceTypeEnum.EventEarlyAccessUser:
			return option.event_baseId && option.event_instance
				? `${option.type}_${option.event_baseId}_${option.event_instance}`
				: option.type;
		default:
			return option.type;
	}
};
